export default __webpack_public_path__ + "static/media/video.4fc342b1.mp4";